import httpClient from './httpClient';

export const fetchCurrentUser = () => httpClient.get('/auth/me', { auth: true });

export const registerUser = (username, email, password) =>
    httpClient.post('/auth/register', { username, email, password });

export const loginUser = (username, password) =>
    httpClient.post('/auth/login', { username, password });

export const verifyCode = (email, code) =>
    httpClient.post('/auth/verify-code', { email, code });

export const resendCode = (email) =>
    httpClient.post('/auth/resend-code', { email });

export const forgotPassword = (email) =>
    httpClient.post('/auth/forgot-password', { email });

export const resetPassword = (email, code, newPassword) =>
    httpClient.post('/auth/reset-password', { email, code, newPassword });

export const fetchRegistrationStatus = () => httpClient.get('/auth/registration-status');

export const updateUsername = (username) =>
    httpClient.put('/auth/me', { username }, { auth: true });

export const updatePassword = (currentPassword, newPassword) =>
    httpClient.put('/auth/password', { currentPassword, newPassword }, { auth: true });

export const requestEmailChange = (newEmail) =>
    httpClient.post('/auth/request-email-change', { newEmail }, { auth: true });

export const confirmEmailChange = (changeToken, code) =>
    httpClient.post('/auth/confirm-email-change', { changeToken, code }, { auth: true });
